<div class="btn-group w-100">
  <div
    class="btn-background"
    *ngFor="let item of selectList | keyvalue : originalOrder"
  >
    <button
      class="btn btn-primary p-1 h-100"
      [ngClass]="selectList.size >= 4 ? 'custom-btn-sm px-2 px-lg-4' : 'px-4'"
      [class.active]="isSelected(item.key)"
      (click)="onClick(item.key)"
    >
      {{ item.key | strict : strictValueKey! }}
    </button>
  </div>
</div>
